define(function (require) {
    "use strict";

	var LE = require("app");
    var Page = require("ui.components/page/Page");
    var Dialog = require("ui/dialog/Dialog");

    var ContentCannedExportModel = require("content-models/canned/ContentCannedExportModel");
    var CannedCollection   = require("content-collections/CannedCollection");
    var ContentCannedTablePageModel = require("content-models/canned/ContentCannedTablePageModel");
    var Constant = require("content-config/constant.json");

    var ContentCannedTableLayout = require("content-views/content-gallery/canned/ContentCannedTableLayout");
    var ContentCannedTableView = require("content-views/content-gallery/canned/ContentCannedTableView");
    var ContentCannedAssignSkillDialogView = require("content-views/content-gallery/canned/ContentCannedAssignSkillDialogView");

    var ContentGalleryComparators = require("content-comparators/ContentGalleryComparators");
    var ContentGalleryFilters = require("content-filters/ContentGalleryFilters");

    var ErrorCodes = require("codeTables/errorCodes.json");

    var ContentCannedTableController = {};

    var TYPES = Constant.CONTENT_TYPES;

    var ADDITIONAL_PAGE_CLASS_NAME = "predefined-messages-page";

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentCannedTableController = Marionette.Controller.extend({

            selectedCannedItemsCollection: null,
            skillsCollection: null,
            contentCannedAssignSkillDialogView: null,
            dialog: null,
            isAcUser: null,
            contentCannedTableLayout: null,
            mainView: null,
            contentCannedTableView: null,

            //------------------------------------------------------------------------
            // initialize
            //------------------------------------------------------------------------
            initialize:function (options) {
                LEContent.logger.info ("initializing","ContentCannedTableController:initialize");
                this.isAcUser = LE.siteSettings.accountSettings.isAcUser();
                this.channel = LEContent.media.channel("ContentCannedTableController");
                this.model = new ContentCannedTablePageModel();
                this.prepareViews();
                this.bindEvents();
            },

            //------------------------------------------------------------------------

            prepareViews: function(){
                this.contentCannedTableLayout = new ContentCannedTableLayout({
                    channel: this.channel,
                    model: this.model,
                    isAcUser: this.isAcUser
                });
                var kp = {
                    text: LE.translator.translate("LEContent.content.gallery.canned.kp.text"),
                    eventId: "predefined-content-managing"
                };
                this.mainView = new Page({
                    moduleName:LEContent.moduleName,
                    context:LE.context,
                    isPermanent: true,
                    view:        this.contentCannedTableLayout,
                    additionalClassName:  ADDITIONAL_PAGE_CLASS_NAME,
                    header: {
                        title: LE.translator.translate("LEContent.content.gallery.canned.title"),
                        description: LE.translator.translate("LEContent.content.gallery.canned.description"),
                        knowledgePack: kp
                    }
                });

                this._createTableView();

                //the context of the callback will be this (this controller)
                this.listenTo(this.contentCannedTableLayout, "render", function () {
                    LEContent.logger.info("onRender of layout called showing all contentGallery regions","contentCannedTableController:initViews");
                    //when the layout is rendered, we"ll setup the inner regions
                    this._showTable();

                },this);


            },
            _createTableView: function() {
                this.contentCannedTableView = new ContentCannedTableView({
                    channel:        this.channel,
                    model:       this.model.getGridViewModel(),
                    collection:  this.model.getOrganizedCollection(),
                    comparators: ContentGalleryComparators,
                    filters:     ContentGalleryFilters,
                    isAcUser:    this.isAcUser
                });
            },

            _showTable: function() {
                this.contentCannedTableLayout.tableRegion.show(this.contentCannedTableView);
            },

            //------------------------------------------------------------------------

            bindEvents: function(){
                //table
                this.listenTo(this.channel,"contentCannedGalleryTable:editItem",this._editItem);
                this.listenTo(this.channel,"contentCannedGalleryTable:selectClicked",this._selectItem);
                //actions
                this.listenTo(this.channel, "contentCannedTableLayout:actions:edit", this._editItem, this);
                this.listenTo(this.channel, "contentCannedTableLayout:actions:delete", this._deleteItem, this);
                this.listenTo(this.channel, "contentCannedTableLayout:actions:categories", this._manageCategories, this);
                this.listenTo(this.channel, "contentCannedTableLayout:actions:add:new:text",this._addNewText);
                this.listenTo(this.channel, "contentCannedTableLayout:actions:add:new:video",this._addNewVideo);
                this.listenTo(this.channel, "contentCannedTableLayout:actions:export", this._exportNewCannedResponses);
                this.listenTo(this.channel, "contentCannedTableLayout:actions:legacyExport",this._exportLegacyCannedResponses);
                this.listenTo(this.channel, "contentCannedTableLayout:actions:import",this._importCannedContent);
                this.listenTo(this.channel, "contentCannedTableLayout:actions:skills",this._assignSkillsToCannedContent);
                //buttons
                this.listenTo(this.channel, "contentCannedTableLayout:change:page", this._pageChange, this);
                this.listenTo(this.channel,"contentCannedTableLayout:buttons:done",this._done);
                this.listenTo(this.channel,"contentCannedTableLayout:buttons:closeWindow",this._done);

                //public api delegation
                this.listenTo(LEContent.vent, "contentGallery:reloadCollection", this.reloadCollection, this);

                LEContent.channel.reply("canned:content-edit:itemPagingInfo", this.getItemIndexInfo,this);
                LEContent.channel.reply("canned:content-edit:itemIdByIndex", this.getItemIDByIndex,this);
            },

            _exportLegacyCannedResponses: function(){
                this.startNotifier = LEContent.notifier.showInfo(LE.translator.translate("LEContent.content.action.legacy.export.start"));
                this._exportCannedResponses(true);
            },

            _exportNewCannedResponses: function(){
                this.startNotifier = LEContent.notifier.showInfo(LE.translator.translate("LEContent.content.action.export.start"));
                this._exportCannedResponses(false);
            },

            _exportCannedResponses: function(legacyFlag){
                var tempModel = new ContentCannedExportModel({legacy: legacyFlag});

                tempModel.fetch({
                    success: _.bind(this._exportCannedResponsesSuccess, this),
                    error:  _.bind(this._exportCannedResponsesError, this)
                });
            },

            _exportCannedResponsesSuccess: function (model, response, options) {
                LEContent.logger.debug("fetch content success - file will download", "ContentCannedTableController:_exportCannedResponsesSuccess");
            },

            _exportCannedResponsesError: function (model, response, options) {
                //need to close the start export notification (if still open) before the error notification can be presented
                this.startNotifier.close();
                delete this.startNotifier;
                var errorMessage;
                if(response && (response.status === 403 || response.status === 401)){
                    errorMessage = LE.translator.translate("LEFramework.errors.serverError.1201");
                }
                else{
                    errorMessage = (response && response.responseError && response.responseError.message) ? response.responseError.message : LE.translator.translate("LEContent.content.action.export.error");
                }

                LEContent.notifier.showError({
                    content: errorMessage,
                    timeToShow: 6000
                });

                LEContent.logger.debug("fetch content error", "ContentCannedTableController:_exportCannedResponsesError");
            },
            //------------------------------------------------------------------------
            // loadData
            //------------------------------------------------------------------------

            loadCannedList: function(){
                this._prepareAfterForloadingCannedResponse();

                // save the previous route for the import flow (navigation to canned page needs to be blocked and
                // redirected to the previous route when import is in progress)
                this._registerContentCannedPreviousRoute();

                // users should not be allowed to access the canned content list page while import is in progress:
                // show the import canned content page instead (while import is in progress its page is initialized with
                // a loader to indicate this).
                if (this._isImportRunningInBackground()) {
                    LEContent.router.navigate('content/canned/import');
                    return;
                }

                this._openLoader();

                var categoriesCollection = LE.crossModule("manager", LE.media.actions.request, LE.mediaCodes.manager.reqres.getCategories);
                categoriesCollection.fetch({
                    silent: true,
                    reset: true,
                    success:  _.bind(this._handleCategoriesLoadSuccess, this),
                    error:  _.bind(this._handleCategoriesLoadError, this)
                });

                if (this.isAcUser) {
                    this.skillsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getSkillsCollection);
                    this.skillsCollection.fetch({
                        success: _.bind(this._handleSkillsLoadSuccess, this),
                        error: _.bind(this._handleSkillsLoadError, this)
                    });
                }

                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    var lobsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getLobsCollection);
                    lobsCollection.fetch({
                        success:  _.bind(this._handleLobsLoadSuccess, this),
                        error:  _.bind(this._handleLobsLoadError, this)
                    });


                    var loggedInUserModel = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getLoggedInUserModel);
                    if (loggedInUserModel.fetchState !== loggedInUserModel.FetchState.SUCCESS && !LE.sessionManager.getConfig().isLPA) {
                        loggedInUserModel.fetch({
                            success: _.bind(this._handleLoggedInUserLoadSuccess, this),
                            error: _.bind(this._handleLoggedInUserLoadError, this)
                        });
                    }
                    else {
                        this._handleLoggedInUserLoadSuccess();
                    }
                }
            },

            _registerContentCannedPreviousRoute: function () {
                LEContent.context.set(LEContent.context.KEYS.cannedContentPreviousApplicationRoute, _.clone(LE.context.get("previousApplicationRoute")));
            },

            _isImportRunningInBackground: function () {
                return LEContent.context.is(LEContent.context.KEYS.cannedContentImportRunningInBackground);
            },

            _handleCategoriesLoadSuccess: function(categories, response, options){
                LEContent.logger.debug("fetch content Categories success ", "ContentCannedTableController:_handleCategoriesLoadSuccess");
                this._callReloadCollection();
            },

            _handleCategoriesLoadError: function(categories, response, options){
                LEContent.logger.error("fetch content Categories error ", "ContentCannedTableController:_handleCategoriesLoadError",response);
                this._callReloadCollection();
            },

            _handleLobsLoadSuccess: function(lobs, response, options){
                LEContent.logger.debug("fetch content Lobs success ", "ContentCannedTableController:_handleLobsLoadSuccess");
                this._callReloadCollection();
            },

            _handleLobsLoadError: function(lobs, response, options){
                LEContent.logger.error("fetch content Lobs error ", "ContentCannedTableController:_handleLobsLoadError",response);
                this._callReloadCollection();
            },

            _handleLoggedInUserLoadSuccess: function(loggedInUser, response, options){
                LEContent.logger.debug("fetch content Logged in user success ", "ContentCannedTableController:_handleLoggedInUserLoadSuccess");
                this._callReloadCollection();
            },

            _handleLoggedInUserLoadError: function(loggedInUser, response, options){
                LEContent.logger.error("fetch content Skills error ", "ContentCannedTableController:_handleLoggedInUserLoadError",response);
                this._callReloadCollection();
            },

            _handleSkillsLoadSuccess: function(skills, response, options){
                LEContent.logger.debug("fetch content Skills success ", "ContentCannedTableController:_handleSkillsLoadSuccess");
                this._callReloadCollection();
            },

            _handleSkillsLoadError: function(categories, response, options){
                LEContent.logger.error("fetch content Skills error ", "ContentCannedTableController:_handleSkillsLoadError",response);
                this._callReloadCollection();
            },

            _prepareAfterForloadingCannedResponse: function() {
                var numberOfFetchsToPerform = 1;
                if (this.isAcUser) {
                    numberOfFetchsToPerform = 2;
                }
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    numberOfFetchsToPerform = 4;
                }
                this._callReloadCollection =  _.after(numberOfFetchsToPerform, function() {
                    this.reloadCollection();
                });
            },

            reloadCollection: function() {
                LE.context.set("content.state", TYPES.CANNED);

                this.model.getCollection().fetch({
                    silent: true,
                    reset: true,
                    success:  _.bind(this._reloadCollectionSuccess, this),
                    error:  _.bind(this._reloadCollectionError, this)
                });
            },

            _reloadCollectionSuccess: function (collection) {
                this.model.getOrganizedCollection().organize({filterModel:this.model.getGridViewModel()});
                this._closeLoader();
                LEContent.channel.trigger('content:cannedCollection:fetch:success', collection);
            },

            _reloadCollectionError: function(){     //todo show something on error when fetching collection  - show error view
                LEContent.logger.error("content reload collection failed", "contentCannedTableController: reloadCollection");
                this._closeLoader();
            },
            //------------------------------------------------------------------------
            // loader
            //------------------------------------------------------------------------

            _openLoader:function () {
                this.mainView.showLoader();
            },

            _closeLoader: function(){
                this.mainView.closeLoader();
            },

            //------------------------------------------------------------------------
            // editItem
            //------------------------------------------------------------------------

            _editItem:function(options){
                var model = {};
                if (_.isObject(options)) {
                    model = options.model;
                } else { //no item id take selected item from collection
                    model = this.model.getCollection().getSelectedModel();
                }
                LEContent.router.navigate("content/canned/" + model.id);
            },
            _selectItem: function (options) {
                var isExclusively =  true;
                if (this.isAcUser) {
                    isExclusively = false;
                }

                if (options.select) {
                    this.model.getCollection().addToSelection(options.model, {exclusively: isExclusively});
                } else {
                    this.model.getCollection().deselectModel(options.model);
                }

            },
            _addNewText: function (){
                LEContent.router.navigate("content/canned/new/text");
            },
            _addNewVideo: function (){
                LEContent.router.navigate("content/canned/new/video");
            },
            _importCannedContent: function (){
                LEContent.logger.info('import canned content called', 'ContentCannedTableController:_importCannedContent');
                this.model.getCollection().clearSelection();
                LEContent.router.navigate("content/canned/import");
            },

            _assignSkillsToCannedContent: function (){
                this.selectedCannedItemsCollection = new CannedCollection();
                var selectedCannedContent = this.model.getCollection().getSelected();
                if (selectedCannedContent.length > 0 ) {
                    this._openLoader();
                    this._fetchSelectedCannedItemsCollection();
                    this._fetchSkillsCollection();
                    this._assignSkillsDataFetchSuccess = _.after(2, this._openAssignSkillsDialog);
                }
            },

            _fetchSelectedCannedItemsCollection: function() {
                LEContent.logger.debug("Fetching selected content items collection", "ContentCannedTableController:_fetchSelectedCannedItemsCollection");
                this.selectedCannedItemsCollection.fetch({
                    fetchParameters: {
                        state:'fetchByIds',
                        ids: this.model.getCollection().getSelectedIds().join(',')
                    },
                    success: _.bind(function () {
                        LEContent.logger.debug("selected content fetched successfully", "ContentCannedTableController:_assignSkillsToCannedContent");
                        this._assignSkillsDataFetchSuccess();
                    }, this),
                    error:_.bind(function(){
                        LEContent.logger.error("selected content fetch failed", "ContentCannedTableController:_assignSkillsToCannedContent");
                        this._closeLoader();
                        LEContent.notifier.showInfo(LE.translator.translate("LEContent.content.gallery.canned.assignSkills.fetchData.error"));
                    }, this)
                });
            },

            _fetchSkillsCollection: function() {
                LEContent.logger.debug("Fetching skills collection", "ContentCannedTableController:_fetchSkillsCollection");
                this.skillsCollection.fetch({
                    success: _.bind(function() {
                        LEContent.logger.debug("skills collection fetched successfully", "ContentCannedTableController:_assignSkillsToCannedContent");
                        this._assignSkillsDataFetchSuccess();
                    }, this),
                    error: _.bind(function(){
                        LEContent.logger.error("Skills collection fetch failed", "ContentCannedTableController:_assignSkillsToCannedContent");
                        this._closeLoader();
                        LEContent.notifier.showInfo(LE.translator.translate("LEContent.content.gallery.canned.assignSkills.fetchData.error"));
                    }, this)
                });
            },

            _openAssignSkillsDialog: function() {
                LEContent.logger.debug("Initiating and openning the assignSkill dialog ", "ContentCannedTableController:_openAssignSkillsDialog");
                this._closeLoader();
                this.contentCannedAssignSkillDialogView = new ContentCannedAssignSkillDialogView({selectedCannedItems: this.selectedCannedItemsCollection, skillsCollection: this.skillsCollection});
                this.mainView.setIgnoreDomEvents(true);
                this.dialog = new Dialog({
                    innerView: this.contentCannedAssignSkillDialogView,
                    moduleName:LEContent.moduleName,
                    context:LE.context
                });
                this.contentCannedTableLayout.dialogContainerRegion.show(this.dialog);
                this.listenTo(this.contentCannedAssignSkillDialogView, "dialogInnerView:closeDialog", this._closeAssignSkillsDialog);
                this.listenTo(this.contentCannedAssignSkillDialogView, "dialogInnerView:onSaveClick", this._saveAssignSkillsDialog);
            },

            _saveAssignSkillsDialog: function(contentToUpdate) {
                LEContent.logger.debug("updating the skills into the selected contents", "ContentCannedTableController:_saveAssignSkillsDialog");
                this._openLoader();
                contentToUpdate.update({
                    success: _.bind(function() {
                        LEContent.logger.debug("assigned skills saved successfully", "ContentCannedTableController:_saveAssignSkillsDialog");
                        this._closeAssignSkillsDialog();
                        this.model.getCollection().clearSelection();
                        this.reloadCollection();
                    },this),
                    error: _.bind(function(collection, response) {
                        this._closeLoader();
                        this._closeAssignSkillsDialog();
                        LEContent.logger.error("updating content with skills failed", "ContentCannedTableController:_onSaveButtonClick");

                        if (response && response.status === 403 && response.responseError && response.responseError.message) {
                            LEContent.notifier.showError(response.responseError.message);
                        }
                        else {
                            if (response && response.responseError && response.responseError.internalCode === ErrorCodes.dependencyConflict) {
                                LEContent.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1001"));
                            }
                            else {
                                LEContent.notifier.showError(LE.translator.translate("LEContent.content.gallery.canned.assignSkills.error"));
                            }
                        }
                    }, this)
                });
            },
            /**
             *
             * @private
             */
            _closeAssignSkillsDialog: function() {
                LEContent.logger.debug("Closing the assignSkill dialog", "contentCannedTableController:_closeAssignSkillsDialog");
                this.stopListening(this.contentCannedAssignSkillDialogView);
                this.contentCannedTableLayout.dialogContainerRegion.close();
                this.contentCannedAssignSkillDialogView = null;
                this.dialog.close();
                this.dialog = null;
                this.mainView.setIgnoreDomEvents(false);
            },

            _pageChange: function (currentPageNumber) {
                this.model.pageNumberChange(currentPageNumber);
            },

            _deleteItem: function(){
                this.selectedContentModel = this.model.getCollection().getSelectedModel();

                LEContent.notifier.showConfirm({
                    title: LE.translator.translate("LEContent.content.table.delete.confirm.title"),
                    content: LE.translator.translate("LEContent.content.table.delete.confirm.text"),
                    objectAction: {
                        text: LE.translator.translate("LEFramework.global.captions.yes"),
                        callback: _.bind(this._deleteContent, this)
                    }
                });
            },

            _deleteContent: function(){
                this._openLoader();
                var that = this;

                this.selectedContentModel.destroy({
                    success: function(){
                        that._closeLoader();
                        that.model.getCollection().clearSelection();
                    },
                    error: function(model, resp, options){
                        that._closeLoader();

                        var errorMessage = LE.translator.translate("LEContent.content.table.delete.error.text");
                        if (resp && resp.status === 403 && resp.responseError && resp.responseError.message) {
                            if (resp.responseError.internalCode == ErrorCodes.maxActionsLimitViolation) {
                                errorMessage = LE.translator.translate("LEContent.content.errors.max.number.of.actions");
                            } else {
                                errorMessage = resp.responseError.message;
                            }
                        }

                        LEContent.notifier.showError({
                            title: LE.translator.translate("LEContent.content.table.delete.error.title"),
                            content:errorMessage,
                            "objectAction":{
                                text: LE.translator.translate("LEFramework.global.captions.ok"),
                                callback: function(){}
                            },
                            removeAditionalButton: true
                        });
                    },
                    wait: true
                });
            },

            //functions for paging in edit content:

            getItemIndexInfo: function (model) {
                var result = {currentPageNumber: 0, totalPages: 1};
                var colin = LE.sessionManager.hasEntitiesTaggingByLobFeature() ? this.model.getOrganizedCollection() : this.model.getCollection(); //colin is a nice good and solid collection name please dont change it or risk my wrath
                var foundModel =  colin.findWhere({id: model.id});//cant do index of model when model is not really in the collection
                if (foundModel){
                    result.currentPageNumber = colin.indexOf(foundModel); //we keep here the indexing of js (first element is 0, view component will decide how to show it as 0 or 1)
                    result.totalPages        = colin.length;
                }

                return  result;
            },

            getItemIDByIndex: function (currModel,index) {
                var collection = LE.sessionManager.hasEntitiesTaggingByLobFeature() ? this.model.getOrganizedCollection() : this.model.getCollection();
                var model = collection.at(index);
                return  model.id;
            },

            _manageCategories: function() {
                LE.crossModule("manager", LE.mediaCodes.manager.redirects.manageCategories);
            },

            //------------------------------------------------------------------------
            // done
            //------------------------------------------------------------------------
            _done: function(){
                LEContent.router.navigateBack();
            },

            onClose: function () {
                LEContent.logger.info("closing", "ContentCannedTableController:close");
                this.channel.reset();
                this.contentCannedTableLayout.close();
                this.mainView.close();
                this.reqres.removeHandler("canned:content-edit:itemPagingInfo");
                this.reqres.removeHandler("canned:content-edit:itemIdByIndex");
            },

            //------------------------------------------------------------------------
            // getMainView
            //------------------------------------------------------------------------

            getMainView: function() {
                return this.mainView;
            }
        });
    });
    return  ContentCannedTableController;
});
